import { SVGProps } from "react";

export interface PodItem {
    sys_id: string;
    u_detail: string;
    u_primary: string;
    u_type: string;
    u_parent: string;
    sys_updated_by: string;
    sys_created_on: string;
    u_poc: string;
    sys_mod_count: string;
    sys_updated_on: string;
    sys_tags: string;
    sys_created_by: string;
}

export interface RoleItem extends PodItem {
}

export interface AddUserToPodFormData {
    v_tdsp_user_would_you_like_to_add_or_remove_a_user: string;
    v_tdsp_point_of_contact: string;
    v_tdsp_description: string;
    v_tdsp_business_justification: string;
    v_tdsp_pod_needed: { [podName: string]: string };
    v_tdsp_user_select_role_s: { [roleName: string]: string };
    v_opened_by: string;
}

export interface OnboardingRequestItem {
    created_at: string;
    request_number: string;
    description: string;
    user_email: string;
    change_request_id: string;
    status: string;
    onboarding_type: OnboardingType;
    opened_by: string;
}

export enum ModelModelType {
    "SingleModel" = "SingleModel",
    "MultiModel" = "MultiModel"
}

export type TSVGElementProps = SVGProps<SVGSVGElement>

export interface RequestDetails {
    request_id: string;
    request_at: string;
    onboarding_type: string;
    ritm_number: string;
    request_sys_id: string;
    request_details: {
        pod_name: string;
        email: string;
        name: string;
        user_role: string;
        description: string;
        business_justification: string;
        ambassador_email: string;
    };
    request_status: Array<{
        status: string;
        request_item: string;
        created_at: string;
        meta_data: any;
    }>;
    request_stage: string;
    cloud_request_details?:any
    request_number:string;
}

export interface CronSchedulerFields {
    pod_name: string;
    author: string;
    team_name: string;
    team_email_address: string;
    project_name: string;
    model_mode: string;
    modelConfigurations?: {
        wandb_project_name: string;
        model_name_custom: string;
        wandb_model_version: string;
    }[];
    batch_strategy: string;
    input_type: string;
    input_inference_path: string;
    output_inference_path: string;
    instance_count: number;
    max_payload_inmb: number;
    max_concurrent_transforms: number;
    enable_schedule?: string;
    minute?: string;
    hour?: string;
    dayOfMonth?: string;
    month?: string;
    dayOfWeek?: string;
    year?: string;
    github_user_id?: string;
    pat_token?: string;
    instance_type: string;
    template_creation_option: string;
  };
  
export interface PodOnboardingRequestBody {
    v_opened_by: string;
    v_tdsp_point_of_contact_new: string;
    v_business_justification: string;
    v_tdsp_description: string;
    v_tdsp_team_business_name_needed: string;
    v_notes_comments: string;
    users: {
        email?: string;
        role: string;
    }[] | undefined;
    architecture_diagram_file: string | ArrayBuffer | null;
    pod_name_abbr: string;
    v_is_wandb_onboarding_enabled: boolean;
}

export enum OnboardingType {
    user_onboarding = "user_onboarding",
    pod_onboarding = "pod_onboarding",
}

export enum ServicesEnum {
    SageMaker="SageMaker",
    DataBricks="DataBricks"
}

export interface EndpointFormData {
    pod_name: string;
    author: string;
    team_name: string;
    team_email_address: string;
    project_name: string;

    // Model Configuration
    model_mode: string;
    modelConfigurations?: Array<{
        wandb_project_name: string;
        model_name_custom: string;
        wandb_model_version: string;
    }>;
    enable_fastapi?: boolean;

    // Transform job
    variant_name: string;
    instance_count: number;
    instance_type: string;

    // github config
    github_user_id?: string;
    pat_token?: string;
    template_creation_option: string;
}

export interface TrainingFormData {
    // General
    pod_name: string;
    author: string;
    team_name: string;
    team_email_address: string;
    project_name: string;

    // github config
    github_user_id?: string;
    pat_token?: string;
    template_creation_option: string;

    // Compute resource
    instance_count: number;
    instance_type: string;
    volume_size: number;

    // Model configuration
    max_retries?: number;
    train_comp_type: string;
    train_dist_type: string;
    train_s3_uri: string;
    validation_comp_type: string;
    validation_dist_type: string;
    validation_s3_uri: string;
    test_comp_type: string;
    test_dist_type: string;
    test_s3_uri: string;

    // W&B config
    wandb_project_name: string;
    model_name_custom: string;
    wandb_model_version: string;

    // cron job config
    enable_schedule?: string;
    minute?: string;
    hour?: string;
    dayOfMonth?: string;
    month?: string;
    dayOfWeek?: string;
    year?: string;
}

export interface SelectOption {
    readonly value: string;
    readonly label: string;
    readonly isFixed?: boolean;
    readonly isDisabled?: boolean;
}

export interface SearchResult { title: string; page_id: string; }
